const EventName = {

    GLOBAL_LOADER: {
        SHOW: 'GLOBAL_LOADER_SHOW',
        HIDE: 'GLOBAL_LOADER_HIDE'
    },
    ALERT_MESSAGE: {
        SUCCESS: 'SUCCESS_MESSAGE_SHOW',
        ERROR: 'ERROR_MESSAGE_SHOW'
    },

}

export default EventName;
